import { WorkflowHandler } from "./WorkflowHandler";
import { post } from "jquery";
import flatpickr from "flatpickr";
import confirmDatePlugIn from "flatpickr/dist/plugins/confirmDate/confirmDate";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import { BlockPageHelper } from "../Helpers/helpers";
import { WOWorkflowActionNames } from "../WorkOrder/WOWorkflowActionNames";
const Genesis = require("../Genesis.js");

interface Dates {
    actualStartDate: string;
    actualFinishDate: string;
}

export class WorkflowWorkOrderApproveConditionHandler {
    private CONDITION_NAME = 'WorkOrderApproveCondition';

    private failingCondition: any;
    private validationMessage = '';
    private recordId = 0;
    private actionName = '';
    private containerSelector = '';
    private modal: Modal|null  = null;
    private autoReload = true;
    private actualStartDate = '';
    private actualFinishDate = '';
    private title = '';
     
    private promptUserForMessage(): void {
        if (this.actionName == "Work Done") {
            $.get(Genesis.url('/Workflow/GetWorkOrderActualStartEndDate?workOrderId=' + this.recordId))
                .then((dates: Dates) => {
                    this.actualStartDate = dates.actualStartDate;
                    this.actualFinishDate = dates.actualFinishDate;
                    $.get(Genesis.url('/Workflow/WorkOrderApprove?dropdownSystemCode=' + (this.failingCondition.dropdownCode ?? "")))
                        .then((html) => {
                            this.displayModal(html);
                        });
                });
        }
        else {
            $.get(Genesis.url('/Workflow/WorkOrderApprove?dropdownSystemCode=' + (this.failingCondition.dropdownCode ?? "")))
                .then((html) => {
                    this.displayModal(html);
                });
        }
    };
    
    private saveMessage(): void {
        this.blockPageAndDisableButtons();
        const formData = this.collectFormData();

        post({
            url: Genesis.url('/Workflow/SaveWorkOrderApprove'),
            data: formData
        })
            .then(() => this.handlePostSuccess())
            .catch(() => this.handlePostError());
    }

    private blockPageAndDisableButtons(): void {
        BlockPageHelper.block();
        WorkflowHandler.disableButtons();
    }

    private collectFormData(): any {
        const reason = $('#reasonType option:selected').val();
        const comment = $('#message').val();
        const changeDate = $('#statusChangeDate').val();
        const completeSR = $('#completeSR').val();

        return {
            recordId: this.recordId,
            message: comment,
            reasonId: reason === '' ? null : reason,
            changeDate: changeDate === '' ? null : changeDate,
            completeSR: completeSR === '' ? null : completeSR,
            mode: this.failingCondition.mode,
            isMessageMandatory: this.failingCondition.isMessageMandatory === '' ? false : this.failingCondition.isMessageMandatory,
            actionName: this.actionName
        };
    }

    private handlePostSuccess(): void {
        if (this.modal !== null) {
            this.modal.hide();
            let redirectToUrl = '';
            if (this.actionName === WOWorkflowActionNames.ACTION_WorkDone || this.actionName === WOWorkflowActionNames.ACTION_ReturnWorkOrder || this.actionName === WOWorkflowActionNames.ACTION_RiskAssessmentFailed) {
                redirectToUrl = Genesis.url(`/Summary/Index`);
            }
            WorkflowHandler.handleActionButton({}, this.recordId, this.actionName, this.autoReload, redirectToUrl);
        }
    }

    private handlePostError(): void {
        BlockPageHelper.unblock();
        Swal.fire({ title: "Workflow Error", text: "An error occurred updating the Work Order.  Please try again." });
    }

    private displayModal(html: string) {
        html = this.replacePlaceholders(html);
        this.insertHtmlIntoModalPlaceholder(html);
        this.initializeModal();
        this.handleUserMessageSubmit();
        this.configureModalElements();
    }

    private replacePlaceholders(html: string): string {
        const replacements: { [key: string]: string } = {
            "#: title #": this.title,
            "#: action #": this.actionName,
            "#: message #": this.validationMessage,
            "#: headerCss #": this.ComposeHeaderCss(),
            "#: headerIconCss #": this.ComposeHeaderIconCss(),
            "#: commentTitle #": this.actionName === WOWorkflowActionNames.ACTION_WorkDone ? "Summary of work carried out" : "Comment"
        };

        for (const placeholder in replacements) {
            const regex = new RegExp(placeholder, 'g');
            html = html.replace(regex, replacements[placeholder]);
        }

        return html;
    }

    private insertHtmlIntoModalPlaceholder(html: string): void {
        $("#workflowModalPlaceHolder").html(html);
    }

    private initializeModal(): void {
        const workflowModal = document.getElementById('workflowModal');
        if (workflowModal !== null) {
            this.modal = new Modal(workflowModal, { backdrop: 'static', keyboard: false });
        }
    }

    private configureModalElements(): void {
        this.configureEvidenceCheck();
        this.configureReasonTypeContainer();
        this.configureStatusChangeDateContainer();
        this.configureCompleteSRContainer();
        this.configureMessageRequirement();
        this.configureCommentsContainer();

        if (this.modal !== null) {
            this.modal.show();
        }
    }

    private configureEvidenceCheck(): void {
        $("#evidenceCheck").hide();
        if (this.actionName === WOWorkflowActionNames.ACTION_RiskAssessmentFailed || this.actionName === WOWorkflowActionNames.ACTION_ConfirmRiskAssessmentPassed || this.actionName === WOWorkflowActionNames.ACTION_StartWorkRAPassed) {
            $("#evidenceCheck").show();
        }
    }

    private configureReasonTypeContainer(): void {
        $('#reasonTypeContainer').hide();
        if (this.failingCondition.mode === "Reason" || this.failingCondition.Mode === "CompleteAndReason") {
            this.showReasonTypeContainer();
        }
    }

    private showReasonTypeContainer(): void {
        $("#reasonType").show();
        $("#reasonTypeLabel").show();
        $('#reasonTypeContainer').show();
        if (this.failingCondition.defaultDropDownSystemCode !== null) {
            const ddlItem = $(`#reasonType option[data-systemcode='${this.failingCondition.defaultDropDownSystemCode}']`);
            ddlItem.prop("selected", true);
        }
        if (this.actionName === WOWorkflowActionNames.ACTION_RiskAssessmentFailed) {
            $('#reasonType').hide();
            $('#reasonTypeLabel').hide();
            $('#reasonTypeContainer').hide();
        }
        $('#reasonType').attr('required', '')
    }

    private configureStatusChangeDateContainer(): void {
        $('#statusChangeDateContainer').hide();
        if (this.failingCondition.mode === "SetDate") {
            this.showStatusChangeDateContainer();
        }
    }

    private showStatusChangeDateContainer(): void {
        $('#statusChangeDateContainer').show();
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        const dateString = now.toISOString().substring(0, 16);
        $("#statusChangeDate").val(dateString);
       
        if (this.actionName === "Work Done") {
            let minDate = this.actualStartDate;
            if (minDate.length > 16) {
                minDate = minDate.substring(0, 16);
            }
            $('#statusChangeDate').attr('min', minDate);
        }
        $('#statusChangeDate').attr('required', '');
    }

    private configureCompleteSRContainer(): void {
        $('#completeSRContainer').hide();
        if (this.failingCondition.mode === "Complete" || this.failingCondition.Mode === "CompleteAndReason") {
            this.showCompleteSRContainer();
        }
    }

    private showCompleteSRContainer(): void {
        $('#completeSRContainer').show();
        $('#completeSR').attr('required', '');
    }

    private configureMessageRequirement(): void {
        if (this.failingCondition.isMessageMandatory) {
            $('#message').attr('required', '');
        }
    }

    private configureCommentsContainer(): void {
        if (this.actionName === WOWorkflowActionNames.ACTION_ApproveWork || this.actionName === WOWorkflowActionNames.ACTION_Resume) {
            $("#commentsContainer").hide();
        }
    }

    private handleUserMessageSubmit(): void {
        $('#workflow-submitUserMessage').click(() => {
            if (this.isMessageMandatoryForSelectedReason()) {
                this.toggleMessageRequirement();
            }

            const form = this.getForm();
            if (form && this.isFormValid(form)) {
                this.saveMessage();
            }
        });
    }

    private isMessageMandatoryForSelectedReason(): boolean {
        return this.failingCondition.isMessageMandatory && this.failingCondition.dropdownCode === "Work Order Permit Reason";
    }

    private toggleMessageRequirement(): void {
        const selectedSystemCode = $('#reasonType option:selected').data("systemcode");
        if (selectedSystemCode !== this.failingCondition.defaultDropDownSystemCode) {
            $('#message').attr('required', '');
        } else {
            $('#message').removeAttr('required');
            this.failingCondition.isMessageMandatory = false;
        }
    }

    private getForm(): HTMLFormElement | null {
        return document.querySelector("#workOrderApproveForm");
    }

    private isFormValid(form: HTMLFormElement): boolean {
        if (!form.checkValidity()) {
            form.classList.add('was-validated');
            return false;
        }
        return true;
    }

    private ComposeHeaderCss(): string {
        switch (this.actionName) {
            case WOWorkflowActionNames.ACTION_ReturnWorkOrder: return 'bg-red-dark';
            case WOWorkflowActionNames.ACTION_ApproveWork: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_CancelWorkOrder: return 'bg-orange-dark';
            case WOWorkflowActionNames.ACTION_ConfirmRiskAssessmentPassed: return 'bg-blue-dark';
            case WOWorkflowActionNames.ACTION_StartWorkRAPassed: return 'bg-blue-dark';
            case WOWorkflowActionNames.ACTION_StartWork: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_PutOnHold: return 'bg-orange-dark';
            case WOWorkflowActionNames.ACTION_Resume: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_StartWorkNoRA: return 'bg-blue-dark';
            case WOWorkflowActionNames.ACTION_WorkDone: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_RiskAssessmentFailed: return 'bg-red-dark';
            case WOWorkflowActionNames.ACTION_CancelWorkOrderAndCloseSR: return 'bg-orange-dark';
            case WOWorkflowActionNames.ACTION_PermitChecked: return 'bg-orange-dark';
            case WOWorkflowActionNames.ACTION_ApproveQuote: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_RejectQuote: return 'bg-red-dark';
            case WOWorkflowActionNames.ACTION_SubmitQuote: return 'bg-blue-dark';
            case WOWorkflowActionNames.ACTION_ApproveQuoteDot: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_CompleteQuoteApproval: return 'bg-green-dark';            
            default: return 'bg-night-light';
        }
    }

    private ComposeHeaderIconCss(): string {
        switch (this.actionName) {
            case WOWorkflowActionNames.ACTION_ReturnWorkOrder: return 'fa fa-undo color-white';
            case WOWorkflowActionNames.ACTION_ApproveWork: return 'fa fa-check color-white';
            case WOWorkflowActionNames.ACTION_CancelWorkOrder: return 'fa fa-ban color-white';
            case WOWorkflowActionNames.ACTION_ConfirmRiskAssessmentPassed: return 'fa fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_StartWorkRAPassed: return 'fa fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_StartWork: return 'fa fa-sign-out color-white';
            case WOWorkflowActionNames.ACTION_PutOnHold: return 'fa fa-pause color-white';
            case WOWorkflowActionNames.ACTION_Resume: return 'fa fa-play color-white';
            case WOWorkflowActionNames.ACTION_StartWorkNoRA: return 'fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_WorkDone: return 'fa fas fa-check color-white';
            case WOWorkflowActionNames.ACTION_RiskAssessmentFailed: return 'fa fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_CancelWorkOrderAndCloseSR: return 'fa fa-ban color-white';
            case WOWorkflowActionNames.ACTION_PermitChecked: return 'fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_ApproveQuote: return 'fa fa-check color-white';
            case WOWorkflowActionNames.ACTION_RejectQuote: return 'fa fa-ban color-white';
            case WOWorkflowActionNames.ACTION_SubmitQuote: return  'fa fa-check color-white';
            case WOWorkflowActionNames.ACTION_ApproveQuoteDot: return 'fa fa-check color-white';
            case WOWorkflowActionNames.ACTION_CompleteQuoteApproval: return 'fa fa-check color-white';
            default: return '';
        }
    }

    public _handle = (result: any, recordId: number, actionName: string, containerSelector: string): boolean => {
        if (result.failingConditionName !== this.CONDITION_NAME) {
            return false;
        }
        const cond = result.failingConditionName;
        this.failingCondition = result[cond.charAt(0).toLowerCase() + cond.slice(1)]; 
        this.validationMessage = result.message;
        this.recordId = recordId;
        this.actionName = actionName;
        this.containerSelector = containerSelector;
        this.title = this.failingCondition.title;
        this.promptUserForMessage();
        return true; 
    }

    public registerHandler() {
        const handler = new WorkflowWorkOrderApproveConditionHandler()._handle;
        WorkflowHandler.registerHandler(handler);        
    }      
}